module.exports = __webpack_public_path__ + "img/RICARDO_BARBOSA.ba956ff6.jpg";